import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "index container" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { on: { showParent: _vm.showParent } })],
        1
      ),
      _vm.showParentPage
        ? _c(
            "div",
            [
              _c(
                VBreadcrumbs,
                [
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: { exact: true, to: { name: "home", params: {} } },
                    },
                    [_vm._v("Home")]
                  ),
                  _c(VBreadcrumbsDivider, [_vm._v("/")]),
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: {
                        exact: true,
                        to: { name: "dynamicQrCode", params: {} },
                        active: "",
                      },
                    },
                    [_vm._v(" Dynamic Qr Code ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex flex-column flex-md-row" },
                [
                  _c(VTextField, {
                    attrs: {
                      dense: "",
                      placeholder: "Press enter to begin search",
                      "append-icon": "mdi-magnify",
                      outlined: "",
                      clearable: "",
                      label: "Search",
                      hint: "You may use + or - in front of each word to include and exclude keywords. Quotes to match exact phase.",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.search.apply(null, arguments)
                      },
                      "click:clear": _vm.clearSearch,
                      "click:append": _vm.search,
                    },
                    model: {
                      value: _vm.parameters.searchTerms,
                      callback: function ($$v) {
                        _vm.$set(_vm.parameters, "searchTerms", $$v)
                      },
                      expression: "parameters.searchTerms",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column flex-md-row ml-0 ml-md-4 mb-2 mb-lg-0 flex-shrink-0",
                    },
                    [
                      _c(VTextField, {
                        staticClass: "ml-0 ml-lg-3 flex-shrink-0",
                        attrs: {
                          dense: "",
                          outlined: "",
                          clearable: "",
                          label: "ID",
                          "append-icon": "mdi-magnify",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.search.apply(null, arguments)
                          },
                          "click:append": _vm.search,
                          "click:clear": _vm.clearSearch,
                        },
                        model: {
                          value: _vm.parameters.qrId,
                          callback: function ($$v) {
                            _vm.$set(_vm.parameters, "qrId", $$v)
                          },
                          expression: "parameters.qrId",
                        },
                      }),
                      _c(
                        VMenu,
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      VBtn,
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-0 ml-md-2",
                                            attrs: { color: "primary" },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(" Create QR Code ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            545273380
                          ),
                        },
                        [
                          _c(
                            VList,
                            [
                              _c(
                                VListItem,
                                {
                                  attrs: {
                                    to: { name: "worksheetQRCodeForm" },
                                  },
                                },
                                [
                                  _c(VListItemTitle, [
                                    _vm._v("Worksheet"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(VDataTable, {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.dynamicQrCodeList,
                      "items-per-page": _vm.pagination.pageSize,
                      loading: !_vm.dynamicQrCodeProcessed,
                      "server-items-length": _vm.pagination.totalSize,
                      page: _vm.pagination.current,
                      "disable-pagination":
                        !_vm.dynamicQrCodeList ||
                        _vm.dynamicQrCodeList.length < 1,
                      "hide-default-header":
                        !_vm.dynamicQrCodeList ||
                        _vm.dynamicQrCodeList.length < 1,
                      "hide-default-footer":
                        !_vm.dynamicQrCodeList ||
                        _vm.dynamicQrCodeList.length < 1,
                      "item-key": "id",
                      options: _vm.options,
                    },
                    on: {
                      "update:options": [
                        function ($event) {
                          _vm.options = $event
                        },
                        _vm.pageChanged,
                      ],
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.id",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewQrCode(item.uuid)
                                        },
                                      },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-qrcode")])],
                                    1
                                  ),
                                  _c("div", { staticClass: "text-caption" }, [
                                    _vm._v(_vm._s(item.id)),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.staffId",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.staffName))]
                              ),
                              _c("div", { staticClass: "text-caption" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDateYear")(item.createTime)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.type",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(item)
                                    },
                                  },
                                },
                                [_c("div", [_vm._v(_vm._s(item.businessType))])]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.searchText",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "my-2",
                                  staticStyle: { "white-space": "pre" },
                                },
                                [_vm._v(_vm._s(item.searchText))]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _c(
                                VMenu,
                                {
                                  attrs: { "offset-y": "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "mt-3 ml-3",
                                                    attrs: { icon: "" },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("mdi-dots-vertical"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    VList,
                                    { staticClass: "pa-2" },
                                    [
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.edit(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListItemIcon,
                                            [
                                              _c(VIcon, [
                                                _vm._v(" mdi-pencil-outline "),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(VListItemContent, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$vuetify.lang.t(
                                                    "$vuetify.base.edit"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewWorksheets(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListItemIcon,
                                            [
                                              _c(VIcon, [
                                                _vm._v(
                                                  " mdi-card-search-outline "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(VListItemContent, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$vuetify.lang.t(
                                                    "$vuetify.worksheet.worksheet"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.remove(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListItemIcon,
                                            [
                                              _c(VIcon, [
                                                _vm._v(" mdi-delete-outline "),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(VListItemContent, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$vuetify.lang.t(
                                                    "$vuetify.base.delete"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3354684992
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("confirmation-dialog", { ref: "confirm" }),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          model: {
            value: _vm.worksheetsDialog,
            callback: function ($$v) {
              _vm.worksheetsDialog = $$v
            },
            expression: "worksheetsDialog",
          },
        },
        [
          _vm.worksheetsDialog
            ? _c(
                VCard,
                [
                  _c(VCardTitle, { staticClass: "justify-end" }, [
                    _c(
                      "div",
                      [
                        _c(
                          VBtn,
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.worksheetsDialog = null
                              },
                            },
                          },
                          [_c(VIcon, [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    VCardText,
                    { staticClass: "d-flex" },
                    [
                      _c("qr-worksheets", {
                        attrs: { qrCodeId: _vm.selectedQrCode.id },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("div", { staticClass: "text-subtitle-2" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.label.foundX", 0)) +
                    " "
                ),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }